// extracted by mini-css-extract-plugin
module.exports = {"baskets":"styles_baskets__3UTxy","addBackground":"styles_addBackground__3rpSB"};